import { render, staticRenderFns } from "./basicInformation.vue?vue&type=template&id=dda5b27c&scoped=true"
import script from "./basicInformation.vue?vue&type=script&lang=js"
export * from "./basicInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda5b27c",
  null
  
)

export default component.exports